import { render, staticRenderFns } from "./goodsBindSeries.vue?vue&type=template&id=57e4d83a&scoped=true&"
import script from "./goodsBindSeries.vue?vue&type=script&lang=js&"
export * from "./goodsBindSeries.vue?vue&type=script&lang=js&"
import style0 from "./goodsBindSeries.vue?vue&type=style&index=0&id=57e4d83a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4d83a",
  null
  
)

component.options.__file = "goodsBindSeries.vue"
export default component.exports